module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/main/privacy-policy/privacy-policy.component.css
// module id = ./src/app/components/dashboard/main/privacy-policy/privacy-policy.component.css
// module chunks = main